import { render, staticRenderFns } from "./push_notifications.vue?vue&type=template&id=7299f86f&scoped=true&"
import script from "./push_notifications.vue?vue&type=script&lang=js&"
export * from "./push_notifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7299f86f",
  null
  
)

export default component.exports